// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"LoadingScreen__loading___85Lc3","loadingSpinner":"LoadingScreen__loadingSpinner___uuDX-","close":"LoadingScreen__close___2OfQi"};
    if(module.hot) {
      // 1778083490380
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  